// Client API centralisé — toutes les requêtes passent par REACT_APP_BACKEND_URL
import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true, // envoie le cookie de session httpOnly
});

// Transforme les erreurs FastAPI (string ou tableau 422) en message français lisible
export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
      .join(" ");
  }
  return e?.message || "Une erreur est survenue. Veuillez réessayer.";
}

export default api;
